module.exports = __webpack_public_path__ + "static/learning-a9912dde33cbc4ea8d4dd33aab792dbf.png";